<template>
  <div class="store-card ml-0 mr-0 d-flex align-items-center justify-content-center h5">
    {{ store.name }}
    <!-- <span class="store-managers">
      {{ store.address1 === null || store.address1 === "" ? "" : store.address1 + ","
      }}{{ store.address2 === null || store.address2 === "" ? "" : store.address2 + "," }}
    </span>
    <span class="store-managers">
      {{ store.city === null || store.city === "" ? "" : store.city + "," }}
      {{ store.province_state === null || store.province_state === "" ? "" : store.province_state + "," }}
      {{ store.postal_code === null || store.postal_code === "" ? "" : store.postal_code }}
    </span> -->
  </div>
</template>

<script>
export default {
  props: ["store"],
  name: "store"
};
</script>

<style lang="scss" scoped>
.store-card {
  padding: 16px 24px;
  width: 100%;
  min-height: 112px;
  max-height: 112px;
  overflow: auto;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  margin-bottom: 24px;
}

.store-card:hover {
  border: 2px solid var(--primary-bg);
  box-sizing: border-box;
  .store-name {
    color: var(--primary-bg);
  }
  .store-managers {
    color: var(--primary-bg);
  }
}

.store-name {
  margin: 3px 0 7px 0px;
  display: block;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #45505b;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.store-managers {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #93a0ad;
  border-radius: 5px;
  line-height: 20px;
  padding: 2px 0 0 0;
}

@media (max-width: 600px) {
  .store-card {
    margin-bottom: 16px;
  }
}
</style>



